import React, { Component } from 'react';
import './App.css';
import Job from './Job.js';
import ContactInfo from './ContactInfo.js';
import Link from './Link.js';
import Objective from './Objective.js';
import Education from './Education.js';
import SkillOutline from './SkillOutline.js';


class App extends Component {
  render() {
    return (
      <div className="Top">
      <div className="App">
        <ContactInfo 
	   phone="512-923-1822"
	   name="Anthony Stevens"
	   address="6711 Rustling Oaks Trail, Austin Tx"
	   email="astevens1@gmail.com"
	/>
	<Objective
	   location="Austin or Remote" >
I consider myself a jack of all things technical. My wide range of experience (System Admin to QA
and Software Developer) provides a unique customer focused view in my work. I have found that I
can come into any environment and quickly become an invaluable member of the team. I am always
eager to learn new things, and share things I have learned.
	</Objective>
	<div className="MainContainer">
	<div className="JobLeft">
        <Job company="Logitech" 
	     title="Lead Audio Firmware Engineer"
	     dateRange="Oct 2018 to Present"
	     skills="C, C++, Javascript, Node (React / Electron), Perl, git"
	>
      I returned to Logitech to lead the Audio Firmware Engineering on the Rally family of video collaboration systems. This was a ground up new software project, which involved developing a real time audio processing engine focused on ARM. The software has been reused on every product since Rally Bar. Also developed several debug tools, including an Electron/React based app to enable debug controls, recording, and audio analysis.

	     </Job>
        <Job company="Athenahealth" 
	     title="Senior Member of Technical Staff"
	     dateRange="June 2017 to Oct 2018"
	     skills="Javascript, Node (React, Redux), Perl, Agile/scrum, git, docker"
	>
I joined Athenahealth during a major technology refocus to invest in a micro-service
architecture. I work on a full stack (Node.js, Perl, Docker, React/Redux) development team using Agile and scrum methodologies
to develop a universal healthcare login and registration service. 
	     </Job>
        <Job company="Gap Year" 
	     title=""
	     dateRange="March 2016 to June 2017"
	>
      I left Logitech/Lifesize to take a year to focus on learning new technologies and traveling.
  During that time, I developed 3 apps, using various tool-kits, including Android Studio (pure
  Java), React-Native, and others. Went through the entire product cycle of planning, developing,
  testing, releasing, and marketing using the Google Play framework. I released the latest
  React-Native projects (Wordplexity and Square Word Scramble) on both Google Play and iTunes stores. However due to ongoing costs, iTunes store was discontinued. See links at bottom for all current apps I have been working on.
	</Job>
        <Job company="Lifesize / Logitech" 
	     title="Senior Audio Software Engineer"
	     dateRange="April 2010 to March 2016"
	>
I worked on the release of every Lifesize Endpoint and MCU product. Majority of the code was
C++, with some PHP, Javascript, and Perl work. Major challenges included debugging
and resolving audio quality issues (echoes, pops, garbled audio, etc), as well as scaling and
latency issues. On multiple occasions, I traveled to customer locations for on-site work and
diagnostics. During those visits, I was able to clearly document both the problem, and any
proposed solutions. One of the more unique items I worked on included a project to utilize
speech to text technology for a voice controlled user interface. I developed several debugging
and automation tools during the course of the job, including a method to graphically plot
conferences to identify quality, latency, and other issues for the Lifesize cloud product. Worked
closely with the Sales Engineers and Support teams to solve complicated customer issues, not
always related to Audio.
	</Job>
        <Job company="Lifesize" 
	     title="Senior Test Engineer"
	     dateRange="April 2007 to April 2010"
	>
Primarily responsible for developing an automated test framework in Perl and XML, and
working with the rest of the test team to implement automated tests. I applied my knowledge
of hardware systems to help evaluate and test early video conference systems. I also created
test plans for 6 major software releases. Maintained and documented multiple firewalls used
for network testing. Worked with development team to discover root cause of software bugs.
Developed automated methods to verify both audio and video were being received and
transmitted.
	</Job>
	</div>
	<div className="SkillRight">
	<SkillOutline
	   programming="C/C++:Perl:Javascript:Java:HTML/CSS" 
	   os="Linux (all distros):Android:macOS:Windows:Solaris"
	   tools="git:subversion:SSH:Jenkins:Jira:Slack:Wireshark:Xcode:Android Studio:Docker:Audacity" 
	   db="Postgres:SQLite3:Oracle"
	   frameworks="Electron:React:React-Native:Redux:Node.js:WebRTC"
	   tech="Realtime Audio:Video Conferencing:VOIP (SIP/H323):HIPPA"
	   >
	</SkillOutline>

	</div>
	</div>
	<div className="PageBreak" />
        <Job company="Newisys" 
	     title="Senior Software Validation Engineer"
	     dateRange="May 2002 to April 2007"
	>
Responsible for validating enterprise servers, storage devices and system management software. 
Lead the Option card validation program. 
Developed test infrastructure to allow for as much automation as possible. 
Developed a system to automatically test BIOS setup screens. 
Developed and maintained LinuxStressTest, which is a complete stress test package for Linux. 
Developed and maintained our System Configuration Tracker tool, which allows us to organize and report test results. 
Maintained a PXE server, complete with automation for hands off OS installations.
Recognized as the Linux subject matter expert. 
Created process, tools, test cases for performing security audits on System Management Devices, discovered numerous critical vulnerabilities.
	</Job>
        <Job company="Solomio" 
	     title="Configuration Management Engineer"
	     dateRange="January 2002 to May 2002"
	>
Maintained the build environment and the Starteam repository. Developed the installation
program for the initial release of the software. Designed, installed, and configured a redundant
Solaris machines with hot failover.
	</Job>
        <Job company="ClearCommerce" 
	     title="QA Engineer"
	     dateRange="February 2000 to October 2001"
	>
Performed Functional Verification Tests and System Verification Tests on various aspects of the
product, focusing mainly on installation and upgrade. All testing efforts were automated using
Perl. Created a web based installation tool which installed an enterprise class software product
on multiple platforms including automatically creating Oracle schemas and seeding databases.
This reduced test setup time by 75% and allowed the test team to quickly recreate a base state
testing environment on demand. This system also allowed for more effective utilization of
hardware by reserving systems for each test effort for a specific amount of time. Created web
based interface to Remedy database which was used by management to track defect status.
Extended this interface to the company chat system. Maintained CVS repository and simplified
the build system to a web interface. Responsible for final product packaging.
	</Job>
        <Job company="Collective Technologies" 
	     title="Systems Admin Consultant"
	     dateRange="February 1998 to October 2000"
	>
	<b>Client:</b>Living.com and Motorola
	</Job>
        <Job company="Computer Sciences Corp" 
	     title="Systems Admin Consultant"
	     dateRange="March 1997 to February 1998"
	>
	<b>Client:</b> IBM in Austin
	</Job>
        <Job company="SageNet Internet Services" 
	     title="UNIX System Adminstrator"
	     dateRange="October 1994 to December 1995"
	>
	</Job>

	<div className="FooterContainer">
	<div className="EduLeft">
	<Education>
	<b>Education:</b>
	Texas State Technical College
	<div>Dec 1995 - Feb 1997</div>
	<div>Computer Networking Degree</div>
	</Education>
        </div>

	<div className="LinkRight">
	<Link >
	<div>
	Google Play Store: <a href="https://play.google.com/store/apps/developer?id=Chaotic.org%20studio">https://goo.gl/1g4jNu</a>
	</div>

	<div>
	LinkedIn: <a href="http://www.linkedin.com/in/anthony-stevens">http://www.linkedin.com/in/anthony-stevens</a>
	</div>
	<div>
	Wordplexity: <a href="https://www.wordplexity.com/">https://www.wordplexity.com/</a>
	</div>
	</Link>
	</div>
	</div>
      </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js